import client, { ClientType } from '../utilities/Client'
export const useClient = (): { client: ClientType } => {
  return { client }
}
